var BrowserState = /** @class */ (function () {
    function BrowserState() {
    }
    BrowserState.prototype.browserDeprecated = function () {
        var isIntertnetExplorer = false || !!document.documentMode;
        if (isIntertnetExplorer) {
            this.showWarning();
        }
    };
    BrowserState.prototype.showWarning = function () {
        var _a;
        (_a = document.getElementById('BrowserDeprecatedNotification')) === null || _a === void 0 ? void 0 : _a.classList.remove("d-none");
    };
    return BrowserState;
}());
export { BrowserState };
